module.exports = __webpack_public_path__ + "static/josh-15fc6b8ac409838308650f8434401984.jpg";